import { Action } from "./actions";
import { Response } from "./response";

export class BackEvent {
    public static fire(action: Action, response: Response): void {

        let event = new CustomEvent<BackEventDetail>("stackedPageReturned", {
            bubbles: true,
            detail: {
                eventType: action.definition.backEventType || BackEventType.close,
                response,

            },
        });
        action.dataHolder["view"].dispatchEvent(event);
    }
}

export interface BackEventDetail {
    eventType: BackEventType;
    response: Response;
}

export enum BackEventType {
    close = "close",
    replay = "replay",
    next = "next",
    previous = "previous",
    fireAnother = "fireAnother",
}
